import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import * as antd from 'antd'

const LandingPage = () => {
	const navigate = useNavigate()

	return (
		<LandingContainer>
			<HeroSection>
				<HeroContent>
					<Logo>GoMStem</Logo>
					<Title>학원 관리의 새로운 기준</Title>
					<Subtitle>
						학생 관리, 출석 체크, 학습일지, 결제 연동까지<br />
						원스톱 학원 운영 솔루션
					</Subtitle>
					<CTAButton onClick={() => navigate('/register/form')}>
						지금 가입하기
					</CTAButton>
				</HeroContent>
			</HeroSection>

			<FeaturesSection>
				<SectionTitle>주요 기능</SectionTitle>
				<FeaturesGrid>
					<FeatureCard>
						<FeatureIcon>👨‍🎓</FeatureIcon>
						<FeatureTitle>학생 관리</FeatureTitle>
						<FeatureDesc>
							학생 정보, 학부모 연락처, 학습 이력을<br />
							한 곳에서 효율적으로 관리
						</FeatureDesc>
					</FeatureCard>
					<FeatureCard>
						<FeatureIcon>✓</FeatureIcon>
						<FeatureTitle>출석 관리</FeatureTitle>
						<FeatureDesc>
							간편한 출석 체크와 자동 알림으로<br />
							학부모와 실시간 소통
						</FeatureDesc>
					</FeatureCard>
					<FeatureCard>
						<FeatureIcon>📝</FeatureIcon>
						<FeatureTitle>학습일지</FeatureTitle>
						<FeatureDesc>
							일일/월간 학습일지 작성으로<br />
							학습 진도 체계적 관리
						</FeatureDesc>
					</FeatureCard>
					<FeatureCard>
						<FeatureIcon>💳</FeatureIcon>
						<FeatureTitle>결제 연동</FeatureTitle>
						<FeatureDesc>
							결제선생 연동으로 간편한<br />
							학원비 청구 및 관리
						</FeatureDesc>
					</FeatureCard>
				</FeaturesGrid>
			</FeaturesSection>

			<CTASection>
				<CTATitle>지금 바로 시작하세요</CTATitle>
				<CTADesc>
					간단한 가입으로 GoMStem의 모든 기능을 무료로 체험해보세요<br />
					관리자 승인 후 바로 사용 가능합니다
				</CTADesc>
				<CTAButton large onClick={() => navigate('/register/form')}>
					가입 신청하기
				</CTAButton>
			</CTASection>

			<Footer>
				<FooterLink onClick={() => navigate('/admin/login')}>
					이미 계정이 있으신가요? 로그인하기
				</FooterLink>
			</Footer>
		</LandingContainer>
	)
}

const LandingContainer = styled.div`
	min-height: 100vh;
	background: #ffffff;
`

const HeroSection = styled.section`
	background: linear-gradient(135deg, #800020 0%, #a03040 100%);
	color: white;
	padding: 80px 20px;
	text-align: center;
`

const HeroContent = styled.div`
	max-width: 800px;
	margin: 0 auto;
`

const Logo = styled.h1`
	font-size: 48px;
	font-weight: 700;
	margin-bottom: 24px;
	letter-spacing: 4px;
`

const Title = styled.h2`
	font-size: 32px;
	font-weight: 600;
	margin-bottom: 16px;
`

const Subtitle = styled.p`
	font-size: 18px;
	line-height: 1.6;
	margin-bottom: 32px;
	opacity: 0.9;
`

const CTAButton = styled.button<{ large?: boolean }>`
	background: white;
	color: #800020;
	border: none;
	padding: ${props => props.large ? '16px 48px' : '12px 32px'};
	font-size: ${props => props.large ? '20px' : '16px'};
	font-weight: 600;
	border-radius: 8px;
	cursor: pointer;
	transition: all 0.3s ease;

	&:hover {
		transform: translateY(-2px);
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
	}
`

const FeaturesSection = styled.section`
	padding: 80px 20px;
	background: #f8f9fa;
`

const SectionTitle = styled.h3`
	font-size: 28px;
	font-weight: 600;
	text-align: center;
	margin-bottom: 48px;
	color: #333;
`

const FeaturesGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
	gap: 24px;
	max-width: 1000px;
	margin: 0 auto;
`

const FeatureCard = styled.div`
	background: white;
	padding: 32px;
	border-radius: 12px;
	text-align: center;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	transition: transform 0.3s ease;

	&:hover {
		transform: translateY(-4px);
	}
`

const FeatureIcon = styled.div`
	font-size: 48px;
	margin-bottom: 16px;
`

const FeatureTitle = styled.h4`
	font-size: 20px;
	font-weight: 600;
	margin-bottom: 12px;
	color: #333;
`

const FeatureDesc = styled.p`
	font-size: 14px;
	line-height: 1.5;
	color: #666;
`

const CTASection = styled.section`
	padding: 80px 20px;
	text-align: center;
	background: white;
`

const CTATitle = styled.h3`
	font-size: 28px;
	font-weight: 600;
	margin-bottom: 16px;
	color: #333;
`

const CTADesc = styled.p`
	font-size: 16px;
	line-height: 1.6;
	color: #666;
	margin-bottom: 32px;
`

const Footer = styled.footer`
	padding: 24px;
	text-align: center;
	background: #f8f9fa;
	border-top: 1px solid #e8e8e8;
`

const FooterLink = styled.a`
	color: #800020;
	cursor: pointer;
	text-decoration: none;

	&:hover {
		text-decoration: underline;
	}
`

export default LandingPage
